import { render, staticRenderFns } from "./TransferDashboard.vue?vue&type=template&id=66a69436&scoped=true"
import script from "./TransferDashboard.vue?vue&type=script&lang=js"
export * from "./TransferDashboard.vue?vue&type=script&lang=js"
import style0 from "./TransferDashboard.vue?vue&type=style&index=0&id=66a69436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a69436",
  null
  
)

export default component.exports